export const SET_LOADING = 'SET_LOADING';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const CLEAR_AUTH_TOKEN = 'CLEAR_AUTH_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const FETCH_SIGHT_WORDS = 'FETCH_SIGHT_WORDS';
export const INSERT_SIGHT_WORD = 'INSERT_SIGHT_WORD';
export const UPDATE_SIGHT_WORD = 'UPDATE_SIGHT_WORD';
export const DELETE_SIGHT_WORD = 'DELETE_SIGHT_WORD';
export const CLEAR_SIGHT_WORDS = 'CLEAR_SIGHT_WORDS';
export const FETCH_PHRASES = 'FETCH_PHRASES';
export const INSERT_PHRASE = 'INSERT_PHRASE';
export const UPDATE_PHRASE = 'UPDATE_PHRASE';
export const DELETE_PHRASE = 'DELETE_PHRASE';
export const CLEAR_PHRASES = 'CLEAR_PHRASES';
export const RESET_STATE = 'RESET_STATE';
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';